import React, { Component } from 'react';
import moment from 'moment'
import { withRouter } from 'react-router'


export default withRouter(class ChartTooltip extends Component {
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.number,
  }

  render() {
    const { active } = this.props;

    if (active) {
      const { payload, label } = this.props;

      var height = "?"
      if(typeof payload !== 'undefined' && payload !== null && payload.length > 0) {
        height = payload[0].value
      }

      return (
        <div style={{border: "2px solid black", background: "#fff", padding: "6px"}}>
            {moment.unix(label).format("dddd, D/MM/YYYY, h:mm a")}<br />
            Height: {height} mm
        </div>
      );
    }

    return null;
  }
})


// WEBPACK FOOTER //
// ./src/components/ChartToolTip.js